import styled from "styled-components";
import sectionBg from "../../../assets/images/HomeBg.webp";

export const Container = styled.section`
  width: 100%;
  position: relative;
  margin: 0px auto 0px;

  padding-bottom: 0;
  transition: all 0.2s;
  .container {
    max-width: 1212px;
    width: 100%;
    display: flex;
    place-content: flex-start;

    align-items: center;
    margin: 0px auto;
    padding: 0px 30px;
    flex-direction: column;
    position: relative;
    .home_btn {
      margin-top: 40px;
      a {
        margin-right: 10px;
      }
    }
  }
  .hero-text-img {
    height: auto;
    max-width: 100%;
    max-height: 695px;
    width: auto;
    z-index: 0;
    position: relative;
    bottom: 9px;
    right: 4px;
  }
  .dc-contract {
    font-size: 14px;
    letter-spacing: 0;
    margin: 0;
    cursor: pointer;
    z-index: 1;
    position: relative;
    display: flex;
    align-items: center;
    img {
      margin: 0 20px;
      width: 25px;
    }
    &--mobile {
      display: block;
    }
    &--desktop {
      display: none;
    }
  }
  .desktop {
    display: none;
  }

  @media screen and (min-width: 650px) {
    .dc-contract {
      &--mobile {
        display: none;
      }
      &--desktop {
        display: block;
      }
    }
  }

  @media screen and (min-width: 1000px) {
    max-width: 1380px;
    min-height: 656px;
    .dc-home-title {
      margin-top: 20px;
    }
    .dc-home-text {
      max-width: 42%;
    }
    .dc-contract {
      margin-top: 20px;
    }
    .mobile {
      display: none;
    }
    .desktop {
      display: block;
    }
    .container {
      align-items: flex-start;
    }
    .home_btn {
    }
    .hero-text-img {
      position: absolute;
      bottom: 9px;
      right: 4px;
      max-width: 60%;
      height: 100%;
    }
  }
`;

export const BannerBg = styled.div`
  /* position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%; */
  overflow: hidden;
  background: transparent;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background: transparent;
`;
